import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { FileText, Search, PenTool, Truck } from 'lucide-react';

const HowItWorksSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const steps = [
    { number: '1', icon: FileText, titleKey: 'howItWorks.step1Title', descKey: 'howItWorks.step1Desc' },
    { number: '2', icon: Search, titleKey: 'howItWorks.step2Title', descKey: 'howItWorks.step2Desc' },
    { number: '3', icon: PenTool, titleKey: 'howItWorks.step3Title', descKey: 'howItWorks.step3Desc' },
    { number: '4', icon: Truck, titleKey: 'howItWorks.step4Title', descKey: 'howItWorks.step4Desc' }
  ];

  return (
    <section id="process" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">{t('howItWorks.title')}</h2>
          <p className="text-xl text-gray-600">{t('howItWorks.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-red-200 z-0" />
              )}
              <div className="relative z-10 bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100">
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                  {step.number}
                </div>
                <div className="mb-6 mt-2">
                  <div className="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center group-hover:bg-red-100 transition-colors duration-300">
                    <step.icon className="w-8 h-8 text-red-600" />
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 whitespace-nowrap">{t(step.titleKey)}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center items-center">
          <Button size="lg" variant="outline" className="border-2 border-red-600 text-red-600 hover:bg-red-50 font-semibold px-10 py-6 text-lg rounded-lg transition-all duration-300" onClick={() => navigate('/turnkey-services')}>
            {t('howItWorks.learnMore')}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
